import React from "react"
import { Link } from "react-router-dom"
import glamorous from "glamorous"
import style from "utils/style"

const HowWeHelp = props => (
  <Wrapper>
    <Header>What Makes Camps and Campers Unique?</Header>
    <Text>
      To learn more about what makes Camps and Campers different from other camp
      listing sites, read more about{" "}
      <StyledLink to="/features/families">how we help families</StyledLink> and{" "}
      <StyledLink to="/features/camps">how we help camps</StyledLink>
      .
    </Text>
    <Logo src="logo-shadow-min.png" />
  </Wrapper>
)

const Logo = glamorous.img({
  display: "inline-block",
  margin: "auto",
  width: "20%",
  paddingTop: 30,
  "@media (max-width: 450px)": {
    width: "40%",
  },
})

const Header = glamorous.h2({
  color: style.colors.basicallyBlack,
  fontSize: "2em",
  padding: 30,
  display: "inline-block",
  margin: "auto",
  textAlign: "center",
  "@media (max-width: 450px)": {
    paddingLeft: 0,
    paddingRight: 0,
  },
})

const StyledLink = glamorous(Link)({
  textDecoration: "none",
  color: style.colors.gray55,
  ":hover": {
    color: style.colors.darkGreen,
  },
})

const Text = glamorous.div({
  display: "inline-block",
  textAlign: "center",
  margin: "auto",
  fontSize: "1.2em",
  width: "60%",
  padding: 5,
  "@media (max-width: 450px)": {
    paddingLeft: 0,
    paddingRight: 0,
    width: "90%",
  },
})

const Wrapper = glamorous.div({
  display: "flex",
  flexDirection: "column",
  padding: 30,
  "@media (max-width: 450px)": {
    paddingLeft: 0,
    paddingRight: 0,
  },
})

export default HowWeHelp



// WEBPACK FOOTER //
// ./src/scenes/Home/HowWeHelp.js